import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatPercent } from '../utils'

export const mwmDataPerInstallDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'freeTrialPerInstallD0Avg',
      field: 'mwm_free_trial_per_install_d0',
      headerName: 'FreeTrial per Install D0',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'freeTrialPerInstallD10Avg',
      field: 'mwm_free_trial_per_install_d10',
      headerName: 'FreeTrial per Install D10',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'freeTrialPerInstallLifetimeAvg',
      field: 'mwm_free_trial_per_install_lifetime',
      headerName: 'FreeTrial per Install Lifetime',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'subscriberPerInstallD0Avg',
      field: 'mwm_subscriber_per_install_d0',
      headerName: 'Subscriber per Install D0',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'subscriberPerInstallD10Avg',
      field: 'mwm_subscriber_per_install_d10',
      headerName: 'Subscriber per Install D10',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'subscriberPerInstallLifetimeAvg',
      field: 'mwm_subscriber_per_install_lifetime',
      headerName: 'Subscriber per Install Lifetime',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'payingUserPerInstallD0Avg',
      field: 'mwm_paying_user_per_install_d0',
      headerName: 'Paying per Install D0',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'payingUserPerInstallD10Avg',
      field: 'mwm_paying_user_per_install_d10',
      headerName: 'Paying per Install D10',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'payingUserPerInstallLifetimeAvg',
      field: 'mwm_paying_user_per_install_lifetime',
      headerName: 'Paying per Install Lifetime',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'MWM Data per Install',
}
